import React from "react";
import { ConsolidatedExecutivePreview } from "@/pages/fleet/reports/components/ConsolidatedExecutivePreview";
import VehicleDetailSection from "@/pages/fleet/reports/components/VehicleDetailSection";
import type { VehicleDetailData, VehicleSummary } from "@/types/fleet-reports.v2";
import type { FleetReportData } from "@/types/fleet-reports";

type Period = { from: Date; to: Date };

type Props = {
  // Página 1 (read-only)
  summaryData: FleetReportData;

  // Ranking de veículos (ordenado por custo)
  vehiclesSummary: VehicleSummary[];

  // Detalhes de TODOS os veículos
  allVehiclesDetails: Map<string, VehicleDetailData>;
  isLoadingDetails?: boolean;

  // filtros
  period: Period;

  // guardrail
  limitPerCategory?: number;
};

export default function ConsolidatedReportWrapper({
  summaryData,
  vehiclesSummary,
  allVehiclesDetails,
  isLoadingDetails,
  period,
  limitPerCategory = 500,
}: Props) {
  return (
    // Container principal - usado para captura PDF
    <div className="space-y-8 print:space-y-4">
      {/* ✅ Página 1 — Sumário Executivo */}
      <ConsolidatedExecutivePreview data={summaryData} />

      {/* Páginas 2+ — Detalhamento de TODOS os veículos */}
      <div className="space-y-6">
        <div className="bg-card border border-border rounded-xl p-5 shadow-sm">
          <div className="space-y-1">
            <h2 className="text-xl font-bold text-foreground">
              Detalhamento por Veículo
            </h2>
            <p className="text-sm text-muted-foreground">
              {vehiclesSummary.length} veículo(s) ordenado(s) por custo total (maior → menor).
              Cada veículo exibe: combustível, ordens de serviço, planos de manutenção, pneus, despesas, documentos e viagens.
            </p>
          </div>
        </div>

        {vehiclesSummary.length === 0 ? (
          <div className="bg-card border border-border rounded-xl p-8 text-center">
            <p className="text-muted-foreground">
              Nenhum veículo encontrado no período selecionado.
            </p>
          </div>
        ) : (
          vehiclesSummary.map((v, index) => (
            <div key={v.vehicle_id} className="vehicle-detail-section">
              <VehicleDetailSection
                rank={index + 1}
                vehicle={allVehiclesDetails.get(v.vehicle_id) ?? null}
                summaryFallback={v}
                period={period}
                isLoading={isLoadingDetails}
              />
            </div>
          ))
        )}
      </div>
    </div>
  );
}
